<template>
  <div
    class="d-flex middle-xs center-xs"
    data-samora
    :style="{ flexDirection: 'column' }"
  >
    <SamIcon
      class="m-2"
      v-bind="iconConfig"
    />
    <p class="text--body-1--medium">
      {{ title }}
    </p>
    <p class="text--body-2 text--light">
      <template v-if="message">
        {{ message }}
      </template>
      <slot
        v-else
        name="message"
      />
    </p>
  </div>
</template>

<script>
import SamIcon from '../SamIcon/SamIcon.vue';

const DEFAULT_ICON_CONFIG = {
  icon: 'alert-information',
  color: '#3843D0', // $informative--main
  size: 'lg',
};

export default {
  name: 'SamInfoState',
  components: { SamIcon },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    message: {
      type: String,
      required: false,
      default: '',
    },
    iconConfig: {
      /** @type { IconConfiguration } */
      type: Object,
      required: false,
      default: () => DEFAULT_ICON_CONFIG,
    },
  },
};
</script>
